<template>
  <div class="schedule-table">
    <div class="schedule-row">
        <div class="schedule-column">
            <p>19:25</p>
        </div>
        <div class="schedule-column">
            <p>KIRURG</p>
        </div>
    </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>20:15</p>
          </div>
          <div class="schedule-column">
              <p>LOLA KUMTUS</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>21:10</p>
          </div>
          <div class="schedule-column">
              <p>PLASTIC WHORE</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>22:00</p>
          </div>
          <div class="schedule-column">
              <p>VĖLIŲ NAMAI</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>23:05</p>
          </div>
          <div class="schedule-column">
              <p>CRYO</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>00:05</p>
          </div>
          <div class="schedule-column">
              <p>WYCHDOKTOR</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>01:20</p>
          </div>
          <div class="schedule-column">
              <p>BESTIAL MOUTHS</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>AFTERPARTY</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>02:00</p>
          </div>
          <div class="schedule-column">
              <p>DJ NEOONDREED</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>04:00</p>
          </div>
          <div class="schedule-column">
              <p>DJ SHIFTWIND</p>
          </div>
      </div>

      <div class="schedule-row">
          <div class="schedule-column">
              <p>06:00</p>
          </div>
          <div class="schedule-column">
              <p>DJ 4-GOT-10</p>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
    name: "Schedule"
  }
</script>

<style scoped>
  .schedule-table {
    background-color: #0d2f39;
    width: 70%;
    margin: 30px auto 50px;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: left;
    align-content: center;
    color: #cdcdcd;
    font-family: 'Tw Cen MT', 'Champagne-Limousines-Thick', 'Apple Gothic', 'URW Gothic L', 'Avant Garde', 'Futura';
  }

  .schedule-row {
      display: flex;
      text-align: left;
      justify-content: left;
  }

  .schedule-column {
      padding: 10px;
      align-content: center;
      text-align: center;
  }

  p {
      margin: 0;
  }

  .ticket-amount {
    font-weight: bolder;
    color: white;
  }

  .ticket-button {
    width: 50%;
    margin: 20px 0 30px;
    border: 3px solid white;
    cursor: pointer;
    align-content: center;
    border-radius: 3px;
    transition: transform .2s;
  }

  .ticket-button:hover {
    box-shadow: 0 1px 20px rgba(21, 25, 34, 0.8);
    transform: scale(1.01, 1.01);
  }

  @media (max-width: 425px) {
    .ticket-button {
      width: 100%;
    }
  }
</style>